import { createSlice } from "@reduxjs/toolkit";

/**
 * Realistic 10-device Topology:
 * 1. Gateway-Router (Root)
 *    2. SW-Core-01 (Switch)
 *       3. SW-Access-Lobby (Switch)
 *          4. AP-Lobby-01 (AP)
 *             5. Client-iPhone-15 (Client)
 *          6. AP-Lobby-02 (AP)
 *       7. SW-Access-Office (Switch)
 *          8. AP-Office-West (AP)
 *             9. Client-MacBook-Pro (Client)
 *          10. AP-Office-East (AP)
 */

export const mockTopologies = [
  {
    "deviceId": "BC:22:21:15:20:39",
    "macAddress": "BC:22:21:15:20:39",
    "model": "DBG-2000",
    "name": "Gateway-Router",
    "status": "online",
    "tag": "Gateway,Main",
    "type": "router",
    "wireType": "wired",
    "children": [
      {
        "parentPort": 1,
        "childPort": 1,
        "speed": "10G",
        "device": {
          "deviceId": "3C:33:32:14:A2:00",
          "macAddress": "3C:33:32:14:A2:00",
          "model": "DMS-3130-30PS",
          "name": "SW-Core-01",
          "status": "online",
          "tag": "Core,Server-Room",
          "type": "switch",
          "wireType": "wired",
          "children": [
            {
              "parentPort": 23,
              "childPort": 25,
              "speed": "1G",
              "device": {
                "deviceId": "BC:22:28:25:07:31",
                "macAddress": "BC:22:28:25:07:31",
                "model": "DGS-1210-28P",
                "name": "SW-Access-Lobby",
                "status": "online",
                "tag": "Access,Lobby",
                "type": "switch",
                "wireType": "wired",
                "children": [
                  {
                    "parentPort": 1,
                    "childPort": null,
                    "speed": "1G",
                    "device": {
                      "deviceId": "00:7A:82:33:44:53",
                      "macAddress": "00:7A:82:33:44:53",
                      "model": "DAP-X2810",
                      "name": "AP-Lobby-Main",
                      "status": "online",
                      "tag": "AP,Lobby",
                      "type": "ap",
                      "wireType": "wired",
                      "children": [
                        {
                          "parentPort": null,
                          "childPort": null,
                          "speed": "866M",
                          "device": {
                            "deviceId": "00:11:22:33:44:66",
                            "macAddress": "00:11:22:33:44:66",
                            "name": "iPhone-15-Pro",
                            "status": "online",
                            "tag": "Mobile",
                            "type": "client",
                            "wireType": "wireless"
                          }
                        }
                      ]
                    }
                  },
                  {
                    "parentPort": 2,
                    "childPort": null,
                    "speed": "1G",
                    "device": {
                      "deviceId": "00:7A:82:33:44:54",
                      "macAddress": "00:7A:82:33:44:54",
                      "model": "DAP-X2810",
                      "name": "AP-Lobby-Entrance",
                      "status": "online",
                      "tag": "AP,Lobby",
                      "type": "ap",
                      "wireType": "wired"
                    }
                  }
                ]
              }
            },
            {
              "parentPort": 24,
              "childPort": 26,
              "speed": "1G",
              "device": {
                "deviceId": "BC:22:28:25:07:32",
                "macAddress": "BC:22:28:25:07:32",
                "model": "DGS-1210-28P",
                "name": "SW-Access-Office",
                "status": "online",
                "tag": "Access,Office",
                "type": "switch",
                "wireType": "wired",
                "children": [
                  {
                    "parentPort": 5,
                    "childPort": null,
                    "speed": "1G",
                    "device": {
                      "deviceId": "BC:22:28:25:07:38",
                      "macAddress": "BC:22:28:25:07:38",
                      "model": "DAP-X2850",
                      "name": "AP-Office-West",
                      "status": "online",
                      "tag": "AP,Office",
                      "type": "ap",
                      "wireType": "wired",
                      "children": [
                        {
                          "parentPort": null,
                          "childPort": null,
                          "speed": "1.2G",
                          "device": {
                            "deviceId": "00:11:22:33:44:55",
                            "macAddress": "00:11:22:33:44:55",
                            "name": "MacBook-Pro-16",
                            "status": "online",
                            "tag": "Workstation",
                            "type": "client",
                            "wireType": "wireless"
                          }
                        }
                      ]
                    }
                  },
                  {
                    "parentPort": 6,
                    "childPort": null,
                    "speed": "1G",
                    "device": {
                      "deviceId": "BC:22:28:25:07:39",
                      "macAddress": "BC:22:28:25:07:39",
                      "model": "DAP-X2850",
                      "name": "AP-Office-East",
                      "status": "online",
                      "tag": "AP,Office",
                      "type": "ap",
                      "wireType": "wired"
                    }
                  }
                ]
              }
            }
          ]
        }
      }
    ]
  }
];

export const onTopologySlice = createSlice({
  name: "onTopology",
  initialState: {
    resource: 'topology',
    data: [...mockTopologies],
    deviceInfoRegeneratedAt: 1779789060, // 2026-05-26 17:51:00 (GMT+8) 戳記，以秒為單位
    regenerationMock: { success: true },
  },
  reducers: {
    updateRegenerationTime: (state) => {
      state.deviceInfoRegeneratedAt = Math.floor(Date.now() / 1000);
    }
  }
});

export const { updateRegenerationTime } = onTopologySlice.actions;

export default onTopologySlice.reducer;